<template>
  <div class="container">
    <p class="lead">What 10min of parsing wikipedia can do</p>
    <div class="row mb-3">
      <div v-if="loading" class="col-4 themed-grid-col">loading... :p</div>
      <section class="filters">
        <div class="btn-group">
          <div class="dropdown" v-for="filter in filters" :key="filter">
            <button
              class="btn btn-secondary dropdown-toggle"
              type="button"
              :id="filter"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ filter }}
            </button>
            <ul class="dropdown-menu" :aria-labelledby="filter">
              <li :key="value" v-for="value in filterValues.get(filter)">
                <a
                  class="dropdown-item"
                  href="#"
                  @click="filterCars(filter, value)"
                  >{{ value }}</a
                >
              </li>
            </ul>
          </div>
          <button @click="resetFilter()" type="button" class="btn btn-danger">
            Reset filters
          </button>
        </div>
      </section>
      <div
        v-for="car in cars"
        class="col-sm themed-grid-col car"
        :key="car.title"
      >
        <a :href="car.href">
          <h3>{{ car.title }}</h3>
          <img
            loading="lazy"
            :src="(car.data || {}).image || PLACEHOLDER_URL"
          />
          <table>
            <tr v-for="attr in car.meta" :key="attr">
              <td>{{ attr.key }}</td>
              <td>{{ attr.value }}</td>
            </tr>
          </table>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
const PLACEHOLDER_URL =
  "https://assets.oneweb.mercedes-benz.com/plugin/vs/vs-3.7.3/placeholders/limousine_550.jpg";

function extractAllMetaKeys(data) {
  const set = new Set();
  const map = new Map();

  data.forEach((car) => {
    if (car.meta) {
      car.meta.forEach((meta) => {
        set.add(meta.key);
        if (!map.has(meta.key)) {
          map.set(meta.key, new Set());
        }
        map.get(meta.key).add(meta.value);
      });
    }
  });
  return {
    keys: Array.from(set).filter((i) => !i.includes("[")),
    values: map,
  };
}
export default {
  data() {
    return {
      loading: true,
      filters: [],
      filterValues: {},
      cars: [],
      allCars: [],
      PLACEHOLDER_URL,
    };
  },
  mounted() {
    fetch("public/out.json")
      .then((res) => res.json())
      .then((data) => {
        this.cars = data;
        this.allCars = [...data];
        const { keys, values } = extractAllMetaKeys(data);
        this.filterValues = values;
        this.filters = keys;
        this.loading = false;
      });
  },

  methods: {
    resetFilter() {
      this.cars = this.allCars;
    },

    filterCars(filter, value) {
      this.cars = this.allCars.filter((car) => {
        return (
          car.meta &&
          car.meta.find((m) => m.key === filter && m.value === value)
        );
      });
    },
  },
};
</script>
<style>
.filters .btn-group {
  width: 100%;
  flex-flow: wrap;
}
</style>